<template>
    <nav class="controlpanel__nav">
      <v-list>
        <v-list-group
          v-for="companyItem in controlpanelmenu"
          :key="companyItem.title"
          no-action
          active-class="primary--text"
        >
          <v-list-item
            slot="activator"
            class="list-hotfix"
            :to="`/company/${companyItem.id}`"
          >
            <v-list-item-action>
              <v-badge
                left overlap color="red"
                :value="companyItem.notifications > 0"
              >
                <span slot="badge" v-if="companyItem.notifications > 0">{{ companyItem.notifications }}</span>
                <v-icon>business</v-icon>
              </v-badge>
            </v-list-item-action>
            <v-list-item-title>{{ companyItem.title }}</v-list-item-title>
          </v-list-item>
          <template
            v-for="item in companyItem.items"
          >
            <v-list-item
              :key="item.title"
              :to="item.href"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list-group>
        <v-list-item :to="{ name: 'subscription' }" v-if="companies.length > 0">
          <v-list-item-action>
            <v-icon>receipt</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('texts.subscriptionInformation') }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list>
        <v-list-item :to="{ name: 'add.company' }">
          <v-list-item-action>
            <v-icon>add_circle_outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('texts.addCompany') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </nav>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyState } = createNamespacedHelpers('company');

export default {
  name: 'CompanyControlpanelMenu',
  data() {
    return {
    };
  },
  computed: {
    ...mapCompanyState([
      'companies',
    ]),
    controlpanelmenu() {
      const menu = [];
      // Get all companies of the user
      if (Object.keys(this.companies).length > 0) {
        Object.keys(this.companies).forEach((key) => {
          const companyBaseUrl = `/company/${this.companies[key].id}/`;
          const companyBlock = {
            action: 'business',
            title: this.companies[key].name,
            id: this.companies[key].id,
            notifications: this.companies[key].number_of_unread_notifications,
            items: [
              {
                title: 'Dashboard',
                href: `${companyBaseUrl}dashboard`,
              },
              {
                title: this.$i18n.t('texts.profile'),
                href: `${companyBaseUrl}profile`,
              },
              {
                title: this.$i18n.t('texts.jobs'),
                href: `${companyBaseUrl}jobs`,
              },
              {
                title: this.$i18n.t('texts.applications'),
                href: `${companyBaseUrl}applications`,
              },
              {
                title: this.$i18n.t('texts.employee.label'),
                href: `${companyBaseUrl}employees`,
              },
            ],
          };
          menu.push(companyBlock);
        });
      }
      return menu;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-hotfix {
  flex: 1 1 auto !important;
  overflow: hidden;
}

::v-deep {
  .v-list {
    &-item {
      padding: 0;
      &__action {
        margin: 0 16px !important;
      }
      &__icon {
        justify-content: center !important;
      }
      &--active {
        &:before,
        &:hover:before,
        &:focus:before {
          opacity: 0 !important;
        }
      }
    }
    &-group__header  {
      padding-left: 0;
    }
  }
}

</style>
